import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { withSearchHandler } from 'decorators';
import { H1, Paragraph } from 'components/core/Typography';
import { Container } from 'components/core/Page';
import { FramedImage } from 'components/atoms';
import { StickySearch } from 'components/organisms';
import { SearchBox } from 'components/molecules';
import './PSPHero.scss';
import { MarkdownWrapper } from 'components/atoms/MarkdownWrapper';

export const enhance = compose(withRouter, withSearchHandler);

export function PSPHero({ content, handleSearch }) {
	const { title, description, image, subheading, CTAtext, hideCTA } = content;
	return (
		<>
			<header className="psp-hero">
				<Container>
					<div className="psp-hero-content">
						<div className="psp-hero-left">
							<div className="psp-hero-text-wrapper">
								<H1
									size="xlarge"
									color="white"
									weight="extraBold"
									className="psp-hero-title"
								>
									{title}
								</H1>
								<Paragraph
									color="white"
									weight="standard"
									className="psp-hero-description"
								>
									<MarkdownWrapper
										content={[
											{
												key: 'hero_description',
												value: description,
											},
										]}
										componentProps={{
											color: 'white',
											className: description.includes(
												'https://',
											)
												? 'bright-link'
												: '',
										}}
									/>
								</Paragraph>
							</div>
							{!hideCTA && (
								<div className="psp-hero-search-wrapper">
									<Paragraph
										color="white"
										weight="standard"
										className="psp-hero-description"
									>
										{subheading}
									</Paragraph>
									<SearchBox
										inputLabel=""
										onSearch={handleSearch}
										id="psp-hero-sticky-search"
										useBrowserLocation
										withSearchType={false}
										buttonText={CTAtext || 'Find Units'}
										hideOnScroll
									/>
								</div>
							)}
						</div>
						<div className="psp-hero-right">
							<FramedImage
								src={image}
								className="psp-hero-image"
								alt={title}
							/>
						</div>
					</div>
				</Container>
			</header>
			<StickySearch
				triggerId="psp-hero-sticky-search"
				handleSearch={handleSearch}
			/>
		</>
	);
}

PSPHero.propTypes = {
	content: PropTypes.shape({
		title: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		image: PropTypes.string.isRequired,
		subheading: PropTypes.string.isRequired,
		CTAtext: PropTypes.string.isRequired,
		hideCTA: PropTypes.bool,
	}).isRequired,

	handleSearch: PropTypes.func.isRequired,
	withSearchType: PropTypes.bool,
};

PSPHero.defaultProps = {
	content: {
		title: 'Find the perfect storage unit at the best price',
		description:
			'Search more locations and units than any other storage site',
		image: '',
		storageType: 'Vehicle',
	},
	headline: 'Find the perfect storage unit at the best price',
	subheading: 'Search more locations and units than any other storage site',
	withSearchType: true,
};

export default enhance(PSPHero);
